import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "9",
  height: "10",
  viewBox: "0 0 11 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.195 1v11.657H9.68V1H6.195ZM1 1v11.657h3.483V1H1Z",
  stroke: "#000",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.18 2.817a.458.458 0 0 0-.445-.466.454.454 0 0 0-.446.466c0 .26.199.466.446.466a.454.454 0 0 0 .446-.466ZM3.18 4.49a.458.458 0 0 0-.445-.466.454.454 0 0 0-.446.466c0 .261.199.467.446.467a.454.454 0 0 0 .446-.467ZM8.376 2.817a.458.458 0 0 0-.446-.466.454.454 0 0 0-.446.466c0 .26.2.466.446.466a.454.454 0 0 0 .446-.466ZM8.376 4.49a.458.458 0 0 0-.446-.466.454.454 0 0 0-.446.466c0 .261.2.467.446.467a.454.454 0 0 0 .446-.467Z",
  fill: "#000"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };